import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function BBLForeverYoung() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-237">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-238">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-239">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-240">
            BBL FOREVER YOUNG
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-241"></div>

          <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body" data-id="element-242">
            <p data-id="element-243">
              BBL Forever Young is a cutting-edge photorejuvenation treatment
              that utilizes BroadBand Light (BBL) technology to address various
              signs of aging and sun damage. This treatment stimulates the
              production of collagen and elastin in the skin, resulting in
              improved skin texture, reduced fine lines and wrinkles, and a more
              youthful appearance.
            </p>
            <p data-id="element-244">
              BBL Forever Young can effectively target areas of sun damage,
              pigmentation irregularities, redness, and vascular lesions. With
              regular treatments, BBL Forever Young can help maintain
              youthful-looking skin and prevent future signs of aging.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}